import { FilterOption, PlpHierarchyFilterItemProps } from '../PlpFilters.type';
import { FilterName } from 'src/plp/components/FilterName/FilterName';
import { IconPetrol } from 'src/general/Icons/IconPetrol';
import { FilterOptionFieldsGroup } from '../components/Fields/FilterOptionFieldsGroup';
import { FilterAccordion } from '../components/FilterAccordion/FilterAccordion';

type Props = PlpHierarchyFilterItemProps<FilterOption>;

export const FilterFuelType = ({ options, currentFilters, index, showNotificationBadge, ...props }: Props) => {
  const id = 'fuelType';
  const header = <FilterName icon={<IconPetrol />} label="Fuel type" showNotificationBadge={showNotificationBadge} />;
  const content = (
    <FilterOptionFieldsGroup
      options={options.map((option) => ({ ...option, label: option.label ?? '' }))}
      currentFilters={currentFilters}
      {...props}
    />
  );

  return <FilterAccordion id={id} header={header} content={content} index={index} />;
};
